module.exports = __webpack_public_path__ + "img/dialog-bg.c9ddf35b.png";